import React from 'react';
import styles from './moderation-pending-chats.module.scss';
import { Typography } from '@/ui-kit';
import { ModerationPendingIcon } from '@/assets/icons';
import { useTranslation } from 'react-i18next';

interface Props {}

export const ModerationPendingChats: React.FC<Props> = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.wrapper}>
            <ModerationPendingIcon className={styles.remoderationCardContentIcon} />
            <Typography
                fontWeight="semibold"
                center
                fontFamily="SFProText"
                className={styles.title}>
                {t('your_profile_is_being_reviewed')}
            </Typography>
            <Typography
                center
                fontFamily="SFProText"
                className={styles.text}>
                {t('we_are_currently_checking_your_info')}
            </Typography>
        </div>
    );
};
